import { render, staticRenderFns } from "./NotesLanding.vue?vue&type=template&id=755733ae&scoped=true&"
import script from "@/scripts/Notes/NotesLanding/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NotesLanding/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755733ae",
  null
  
)

export default component.exports